exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "* {\n  margin: 0;\n  padding: 0; }\n\nbody {\n  width: 100%;\n  height: 100%; }\n\n#page {\n  position: relative; }\n\n#page canvas, .container {\n  position: absolute; }\n\n.container {\n  width: 100%; }\n\np {\n  /* height: 90px; */\n  /* line-height: 90px; */\n  /* text-align: center; */ }\n\np span {\n  display: block; }\n\n.centered {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -ms-flex-align: center;\n  align-items: center;\n  height: 200px; }\n\ncanvas {\n  width: 100%; }\n", ""]);

// exports
